module.exports = __webpack_public_path__ + "static/ACCM-5e4a4a8d660e407083402548846615fd.jpg";